import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Header, Grid } from 'semantic-ui-react';
import * as _ from 'lodash';
import ReactTable from 'react-table';

import {
  getBasicSetup,
  postBasicSetupDelete,
  postBasicSetupInsertUpdate,
  clearBasicSetup,
} from './state/actions';

import { Filter, Main } from 'Containers';
import BasicSetupForm from './components/BasicSetupForm';
import { FieldEnum } from 'Common/FieldEnum';
import { NotificationMessage, DirtyWrapper } from 'Components';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';

class BasicSetupContainer extends Component {
  state = {
    open: false,
    rowData: { Id: 0, Description: '', Status: false },
    size: 'mini',
    isValid: false,
    showDeleteModal: false,
  };

  componentWillMount() {
    this.props.getBasicSetup(this.props.resourcename);
  }

  componentWillUnmount() {
    this.props.clearBasicSetup();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.idleTimeUTC !== this.props.idleTimeUTC) {
      return false;
    }

    return true;
  }

  show = (dimmer, size) => {
    return () => {
      return this.setState({ dimmer, size, open: true });
    };
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.basicSetup.Errors !== this.props.basicSetup.Errors &&
      this.props.basicSetup.Errors &&
      this.props.basicSetup.Errors.length > 0
    ) {
      NotificationMessage(this.props.basicSetup);
    }
  }

  close = () => this.setState({ open: false });

  deleteBasicSetup = row => {
    this.setState({
      rowData: { Id: row.Id, Description: row.Description, Status: row.Status },
      showDeleteModal: true,
    });
  };

  editBasicSetup = row => {
    this.setState({
      rowData: { Id: row.Id, Description: row.Description, Status: row.Status },
      open: true,
      isValid: true,
    });
  };

  addBasicSetup = () => {
    const { canEditId } = this.props;
    const idValue = canEditId ? '' : 0;

    this.setState({
      rowData: { Id: idValue, Description: '', Status: false },
      open: true,
      isValid: false,
    });
  };

  handleSubmit = values => {
    const { postBasicSetupInsertUpdate, resourcename, canEditId } = this.props;
    const { rowData } = this.state;

    const data = {
      Id: values[FieldEnum.Id],
      Description: _.trim(values[FieldEnum.Description]),
      IsNew: rowData.Id ? false : canEditId,
    };

    postBasicSetupInsertUpdate(resourcename, data).then(result => {
      NotificationMessage(result);
      this.setState({ open: false });
    });
  };

  setIsValid = isValid => {
    this.setState({ isValid });
  };

  handleDialog(result) {
    if (result) {
      const { useQueryString, postBasicSetupDelete, resourcename } = this.props;
      postBasicSetupDelete(
        resourcename,
        this.state.rowData.Id,
        useQueryString
      ).then(result => {
        NotificationMessage(result.response.data);
      });
    }

    this.setState({ showDeleteModal: false });
  }

  clearFilters = () => {
    this.setState({ filtered: [] });
  };
  onFilteredChange = filtered => {
    this.setState({ filtered });
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.editBasicSetup,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.deleteBasicSetup,
      disabledWhen: x => this.props.isReadOnly || x.Status,
    },
  ];

  render() {
    const { open, dimmer, size, rowData } = this.state;
    const {
      humanname,
      basicSetup,
      canEditId,
      sortById,
      isReadOnly,
      showId,
      loading,
      showClearFilter,
      isHeaderLeftAlign,
    } = this.props;

    const columns = [
      {
        Header: isHeaderLeftAlign
          ? () => <span className="ml-5">Description</span>
          : 'Description',
        accessor: 'Description',
        filterable: true,
        resizable: false,
        headerStyle: isHeaderLeftAlign && {
          textAlign: 'left',
        },
      },
      {
        Header: '',
        show: false,
        accessor: 'Status',
      },
      {
        Header: '',
        id: 'menu',
        width: 120,
        sortable: false,
        resizable: false,
        style: { textAlign: 'center' },
        Cell: gridProps => {
          const { blockEditFromId, blockEditToId } = this.props;
          const { Id } = gridProps.row;

          if (Id >= blockEditFromId && Id <= blockEditToId) {
            return null;
          }

          return GridContextMenu({ gridProps, options: this.menuOptions });
        },
      },
      {
        Header: 'Status',
        accessor: 'Status',
        show: false,
      },
    ];

    if (!showId) {
      columns.unshift({
        Header: 'Id',
        accessor: 'Id',
        maxWidth: 100,
        filterable: true,
      });
    }
    return (
      <Fragment>
        <Filter title={`${humanname} Setup`}>
          <Grid>
            <Grid.Row>
              <Grid.Column floated={'right'} textAlign={'right'}>
                <Button
                  content={`Add ${humanname}`}
                  onClick={this.addBasicSetup}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main>
          {showClearFilter ? (
            <Button
              className={'clear-filters-button'}
              content="Clear Filters"
              onClick={this.clearFilters}
              visibility="hidden"
            />
          ) : null}
          <ReactTable
            data={_.sortBy(basicSetup.GetData, [
              sortById ? 'Id' : 'Description',
            ])}
            defaultSorted={[{ id: 'Description' }]}
            className={'-striped -highlight grid--fixed-row-height'}
            defaultFilterMethod={caseInsensitiveFilter}
            columns={columns}
            minRows={0}
            pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
            defaultPageSize={10}
            noDataText="No rows found"
            loading={loading}
            filtered={this.state.filtered}
            onFilteredChange={filtered => this.onFilteredChange(filtered)}
          />

          <DirtyWrapper
            closeModalYesCallback={this.close}
            isReadOnly={isReadOnly}
          >
            {showDirtyConfirm => (
              <Modal
                dimmer={dimmer}
                size={size}
                open={open}
                onClose={showDirtyConfirm}
                closeIcon
                closeOnRootNodeClick={false}
              >
                <Header
                  content={
                    rowData.Id === 0
                      ? `Add ${humanname}`
                      : `Edit ${rowData.Description}`
                  }
                  icon="signup"
                />
                <Modal.Content className="p-t-0">
                  <Modal.Description>
                    <BasicSetupForm
                      setIsValid={this.setIsValid}
                      ref={instance => {
                        this.form = instance;
                      }}
                      onSubmit={this.handleSubmit}
                      initialValues={{
                        [FieldEnum.Id]: rowData.Id,
                        [FieldEnum.Description]: rowData.Description,
                      }}
                      canEditId={rowData.Id ? false : canEditId}
                      humanname={humanname}
                      basicSetup={basicSetup.GetData}
                    />
                  </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    inverted
                    color="orange"
                    size="big"
                    content="Save"
                    onClick={() => {
                      this.form.submit();
                    }}
                    disabled={isReadOnly || !this.state.isValid}
                  />
                </Modal.Actions>
              </Modal>
            )}
          </DirtyWrapper>
          <YesNoDialog
            showDialog={this.state.showDeleteModal}
            title={`Delete ${this.props.humanname}`}
            question={` Are you sure you want to delete this ${
              this.props.humanname
            }: ${this.state.rowData.Description}?`}
            yesCallback={() => {
              this.handleDialog(true);
            }}
            noCallback={() => {
              this.handleDialog(false);
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ BasicSetupState }) => {
  return {
    basicSetup: BasicSetupState.basicSetup,
    loading: BasicSetupState.loading,
  };
};

export const BasicSetup = connect(
  mapStateToProps,
  {
    getBasicSetup,
    postBasicSetupDelete,
    postBasicSetupInsertUpdate,
    clearBasicSetup,
  }
)(BasicSetupContainer);



// WEBPACK FOOTER //
// ./src/components/basicsetup/BasicSetup.js